import React from "react";
import { Outlet } from "react-router-dom";
import SupportPage from "@pages/Support/SupportPage/SupportPage";

export default [
    {
        path: "support",
        element: <Outlet />,
        children: [
            {
                path: "",
                element: <SupportPage />,
            },
        ],
    },
];
